<template>
    <div class="group-box" v-loading="loading">
        <div style="width: 100%; line-height: 2" v-show="viewTag == 'list'">
            <el-button
                size="small"
                v-for="(v, i) in recordList"
                :key="v.id"
                :type="shopCompany.countrycode == v.addinfo2 ? 'primary' : ''"
                @click="clickCountryBtn(v)"
            >
                {{v.countryname}}
            </el-button>

            <el-button size="small" @click="changeView('edit')" v-show="addSubcompanyVisible"><font-awesome-icon icon="fa-solid fa-plus" /></el-button>
        </div>

        <div v-show="viewTag == 'edit'">
            <div style="text-align: left; margin-bottom: 10px;">
                <el-button type="info" tkey="返回" @click="changeView('list')">{{i18n.tkey("lang_return")}}</el-button>
            </div>

            <div style="text-align: center; margin-bottom: 10px;">
                <h4 tkey="請選擇地區">{{i18n.tkey("lang_pls_select_region")}}</h4>
            </div>

            <div style="text-align: center">
<!--                <el-button size="large" v-for="(v, i) in countryList" :key="i + 1000" @click="selectMarket(v.countrycode)">{{v.countryname}}</el-button>-->
<!--                <div>-->
                    <countrySelector v-model="selectCountryCode" />
                    &nbsp;
                    <el-button type="primary" @click="selectMarket" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
<!--                </div>-->

            </div>
        </div>

        <div v-if="viewTag == 'input'">
            <div style="text-align: left; margin-bottom: 10px;">
                <el-button type="info" tkey="返回" @click="changeView('list')">{{i18n.tkey("lang_return")}}</el-button>
            </div>

            <companyShopInfoEditor :countrycode="selectCountryCode" @saveComplete="saveCallback" />
        </div>
    </div>
</template>

<script setup>
    import {onMounted, ref, getCurrentInstance, toRef, inject, watch, computed} from "vue";
    import { useUserinfo } from '@/stores/userinfo'
    import { useCompanyinfo } from "@/stores/companyinfo"
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faPlus } from '@fortawesome/free-solid-svg-icons'
    import record13Api from "@/request/record13Api";
    import countryApi from "@/request/countryApi";
    import companyShopInfoEditor from "@/components/shopopee/company/companyShopInfoEditor"
    import countrySelector from "@/components/shopopee/country/countrySelector"
    import companyApi from "@/request/companyApi";
    import myUtil from "@/util/util";

    library.add(faPlus)

    const userinfoRef = toRef(useUserinfo())
    // const companyInfoRef = toRef(useCompanyinfo())
    const shopCompany = ref({})

    const { setShopCompanyObj } = inject('shopControlFunc', { setShopCompanyObj: () => {} })
    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const i18n = inject("i18n")

    const recordList = ref([])
    const countryList = ref([])
    const selectCountryCode = ref(null)

    const loading = ref(false)
    const viewTag = ref("list")

    const props = defineProps(["showEditBtn"])
    const emits = defineEmits(["changeView"])

    const addSubcompanyVisible = computed(() => {
        let authTag = false

        if (null != shopCompany.value && null != shopCompany.value.additionalrecord11){
            const obj = shopCompany.value.additionalrecord11

            if (null != obj.subcompanyNum && obj.subcompanyNum > 0){
                if (obj.subcompanyNum > recordList.value.length){
                    authTag = true
                }
            }

        }

        return countryList.value.length > 0 && props.showEditBtn !== false && authTag
    })
    
    function getRecord13List() {
        loading.value = true
        const request = record13Api.getUserRecordListByCompanycode
        const params = request.getParams()

        params.addinfo3 = userinfoRef.value.companycode

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                res.detail.forEach((v, i) => {
                    const addinfo2 = v.addinfo2

                    for (let i=0; i<countryList.value.length; i++){
                        const obj = countryList.value[i]

                        if (obj.countrycode == addinfo2){
                            if (userinfoRef.value.lang == "zh" || userinfoRef.value.lang == "szh"){
                                v.countryname = obj.countryname
                            }else{
                                v.countryname = obj.countryname2
                            }

                            countryList.value.splice(i, 1)
                            break;
                        }

                    }

                })

                recordList.value = res.detail
            }
        })

    }

    function getCountry(){
        loading.value = true
        const request = countryApi.getCountryList
        const params = request.getParams()

        request.send(params, (res) => {
            countryList.value = res.detail
            getRecord13List()
        })

    }

    function selectMarket(){
        if (null == selectCountryCode.value){
            myUtil.alertWarning(i18n.tkey("lang_pls_select_region"))
            return
        }

        // selectCountryCode.value = code
        viewTag.value = 'input'
    }

    function changeView(name){
        viewTag.value = name

        emits("changeView")
    }

    function saveCallback(){
        emits("changeView")
        viewTag.value = 'list'
        getCountry()
    }

    function clickCountryBtn(record){
        if (shopCompany.value.countrycode == record.addinfo2){
            return
        }

        changeCompanyObj(record.companycode)
    }

    function changeCompanyObj(companycode){
        loading.value = true
        //先用國家代碼獲取companycode
        const request = companyApi.getCompanyInfo
        const params = request.getParams()

        params.companycode = companycode

        request.send(params, (res) => {
            if (res.code == 200){
                userinfoRef.value.selectCompanycode = res.detail.companycode
                shopCompany.value = res.detail
                setShopCompanyObj(res.detail)
                getCountry()
            }
        })

    }

    onMounted(() => {
        shopCompany.value = getShopCompanyObj()
        getCountry()
    })


</script>

<style scoped>
    .group-box {
        padding-bottom: 10px;
    }
</style>